import React from 'react';
import Text from '../Text/Text';
import './SunPage.css';

const SunPage = (props) => {
    return (
	<div>
		<img src = {props.src} className = 'bigBg' alt = ''/>
            <div className='SunPage '><div className='SunAnimation'> </div> </div>
            <div className='Masha'> </div>
            <Text className='SunText' value={props.value} /> 

	</div>				
    );
    };

export default SunPage;